<template>
  <div id="NoPolicies" style="min-height: inherit; display: flex; flex-direction: column;">
    <Header title="Payroll Self-Reporting" />
    <ErrorList v-if="error" :error="error" />
    <div v-else class="mainbody">
      <div id="content">
        <h2>Payroll Self-Reporting</h2>
        <div class="bracket-green">
          <p>View payment history by going to the History tab.</p>
        </div>
      </div>
      <CompanyInfo />
    </div>
  </div>
</template>

<script>
  import CompanyInfo from './shared/CompanyInfo'
  import ErrorList from './shared/ErrorList'
  import Header from "./shared/Header";
  import {mapState} from "vuex";

  export default {
    name: 'NoReporting',
    components: { Header, CompanyInfo, ErrorList },
    data() {
      return {
        error: null
      }
    },
    computed: {
      ...mapState([ 'policies' ])
    }
  }
</script>

<style scoped>
</style>
